module.exports = __webpack_public_path__ + "img/22.f03bc06d.png";